import React, { useState, useEffect } from "react";
import { Flex, Text, Image, Input, Button } from "@fluentui/react-northstar";
import PropTypes from "prop-types";
import Constants from "../../../constants/text-constants";
import TellUsAboutYouForm from "../../molecules/Forms/TellUsAboutYouForm";
import AboutYouImage from "../../../assets/images/undraw_profile_6l1l.svg";
import accountHandler from "../../../services/api/accountHandler";

const TellUsAboutYouSettings = (props) => {
    const [accountProfile, setAccountProfile] = useState({});
    const { onChangePasswordClick } = props;

    const tellAboutYouOnboardComplete = ({ firstName, lastName, emailAddress, emailVerified }) => {
        // This resets the initial contents of firstname, surname, email, and emailVerified
        // So after saving the props into <TellUsAboutYouForm> are updated to reflect this.
        setAccountProfile({
            firstname: firstName,
            surname: lastName,
            email: emailAddress,
            emailVerified: emailVerified,
        });
    }

    useEffect(() => {
        accountHandler.getAccountProfile().then((resp) => {
            setAccountProfile(resp);
        }).catch((e) => {
            console.warn("getAccountProfile failed", e);
        });
    }, []);

    return (
            <Flex className="tell-us-about-you-settings-container" data-testid="tellUsAboutYouSettings" gap="gap.large" column>
                <Image
                    fluid
                    src={AboutYouImage}
                    data-testid={"tellUsAboutYouSettingsImage"}>
                </Image>
                <TellUsAboutYouForm
                    firstName={accountProfile.firstname ?? ''}
                    lastName={accountProfile.surname ?? ''}
                    emailAddress={accountProfile.email ?? ''}
                    tellAboutYouOnboardComplete={tellAboutYouOnboardComplete}
                    emailVerified={accountProfile.emailVerified ?? null}
                    showEmailVerification={true}
                >
                    <Flex column>
                        <Flex className="tell-us-about-you-settings-pw" data-testid="tellUsAboutYouSettingsPw" vAlign="center">
                            <Text
                                className="tell-us-about-you-settings-pw-text">
                                {Constants.PASSWORD}
                            </Text>
                            <Button
                                className="capitalize tell-us-about-you-settings-pw-change-btn"
                                data-testid={"changePasswordSettingsBtn"}
                                text
                                content={Constants.CHANGE_PASSWORD}
                                onClick={onChangePasswordClick}
                                type="button"
                            />
                        </Flex>
                        <Input
                            fluid
                            disabled
                            value={Constants.FAKE_PASSWORD}
                        />
                    </Flex>
                </TellUsAboutYouForm>
            </Flex >
    );
}

TellUsAboutYouSettings.propTypes = {
    onChangePasswordClick: PropTypes.func,
};

export default TellUsAboutYouSettings;